<div class="qr-quit-message-container">
  <i class="icon-basket"></i>
  <h1 class="title">{{'label.quit.order' | translate}}</h1>
  <h1>{{'desc.return.by.scanning.qr.code' | translate}}</h1>

  <div class="action-container">
    <app-button [borderButton]="true" [buttonName]="'button.cancel'" (click)="remainQrDineInMode()"></app-button>
    <app-button [buttonName]="'label.quit.order'" (click)="quitQrDineInMode()"></app-button>
  </div>
</div>
